import resso from 'resso'

interface ILoginStore {
  phone: string
  agreementChecked: boolean
  rememberAccount: boolean
  loginType: number
}

const getInitialState = (): ILoginStore => {
  return {
    phone: '',
    loginType: 1,
    agreementChecked: true,
    rememberAccount: false
  }
}

export const LoginStore = resso({
  ...getInitialState()
})
